/** Returns machine-level settings from state. */
export const getMachineSettings = (state) => {
  return state?.machineSettings;
};
